@if (!user.isAuthenticated) {
    <lh-cross-product-layout>
        <lh-login (onBackClick)="back()" />
    </lh-cross-product-layout>
}
